import "firebase/firestore";
import { myFirebase } from "../firebase/firebase";

const requestLogin = () => {
    return {
        type: LOGIN_REQUEST
    };
};

const receiveLogin = user => {
    return {
        type: LOGIN_SUCCESS,
        user
    };
};

const loginError = () => {
    return {
        type: LOGIN_FAILURE
    };
};

const emailSent = () => {
    return {
        type: EMAIL_SENT
    };
};

const requestLogout = () => {
    return {
        type: LOGOUT_REQUEST
    };
};

const receiveLogout = () => {
    return {
        type: LOGOUT_SUCCESS
    };
};

const receiveData = () => {
    return {
        type: SAVE_DATA_SUCCESS
    };
};

const DataError = () => {
    return {
        type: SAVE_DATA_FAILURE
    };
};

const logoutError = () => {
    return {
        type: LOGOUT_FAILURE
    };
};

const verifyRequest = () => {
    return {
        type: VERIFY_REQUEST
    };
};

const verifySuccess = () => {
    return {
        type: VERIFY_SUCCESS
    };
};

let actionCodeSettings = {
    // debug mode
    //url: 'http://localhost:3000/home',
    // deploy mode
     url: 'https://babysitterkoda-1a3df.firebaseapp.com/home',
     handleCodeInApp: true
  };

export const sendMagicLink = (email) => dispatch => {
    myFirebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
    .then(function() {      
      window.localStorage.setItem('emailForSignIn', email);
    })
};

export const loginLink = () => dispatch => {
    if (myFirebase.auth().isSignInWithEmailLink(window.location.href)) {
        let email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
        email = window.prompt('Please provide your email for confirmation');
        }
        myFirebase.auth().signInWithEmailLink(email, window.location.href)
        .then(function(result) {
            window.localStorage.removeItem('emailForSignIn');
        })
        .catch(function(error) {
        });
    }
};

export const createNewUser = (email, password) => dispatch => {
    myFirebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(function(user){})
        .catch(error => {
            alert(error);
            window.location.assign("signup");
            dispatch(loginError());
        });
};

// login automatically after sign up
export const loginUserAfterSignup = (email, password) => dispatch => {
    dispatch(requestLogin());
    myFirebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(user => {
            dispatch(receiveLogin(user));
        })
        .catch(error => {
            //Do something with the error if you want!
            dispatch(loginError());
        });
};

// login with magic link
export const loginUser = (email) => dispatch => {
    dispatch(requestLogin());
        myFirebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
        .then(function() {
          // The link was successfully sent. Inform the user.
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          window.localStorage.setItem('emailForSignIn', email);
        })
        .catch(error => {
            //Do something with the error if you want!
            dispatch(loginError());
        });
};

// login with google
export const loginUserByGoogle = (provider) => dispatch => {
    dispatch(requestLogin());
    myFirebase
        .auth()
        .signInWithPopup(provider)
        .then(user => {
            dispatch(receiveLogin(user));
        })
        .catch(error => {
            //Do something with the error if you want!
            dispatch(loginError());
        });
};

export const logoutUser = () => dispatch => {
    dispatch(requestLogout());
    myFirebase
        .auth()
        .signOut()
        .then(() => {
            dispatch(receiveLogout());
        })
        .catch(error => {
            //Do something with the error if you want!
            dispatch(logoutError());
        });
};

export const saveStudentData = (student_data) => dispatch => {
    const baseDb = myFirebase.firestore();
    var user = myFirebase.auth().currentUser
    console.log(student_data);
    baseDb.collection("members").doc(user.uid).set({
        registration_date: student_data.registration_date,
        activity_status: student_data.activity_status,
        email : student_data.email,
        type : "student",
        full_name : student_data.full_name,
        phone_number : student_data.phone_number,
        region : student_data.region,
        cities : student_data.cities,
        current_occupation : student_data.current_occupation,
        age : student_data.age,
        stud_gender : student_data.stud_gender,
        stud_picture: student_data.stud_picture,
        is_no_preference: student_data.is_no_preference,
        is_autistic_spectrum : student_data.is_autistic_spectrum,
        is_intellectual_limitation : student_data.is_intellectual_limitation,
        is_delayed_developed : student_data.is_delayed_developed,
        is_physical_limitation : student_data.is_physical_limitation,
        is_behavioral_difficulty : student_data.is_behavioral_difficulty,
        is_nursing_assistance : student_data.is_nursing_assistance,
        is_medical_assistance : student_data.is_medical_assistance,
        is_other : student_data.is_other, 
        child_age : student_data.child_age,
        relevant_ages: {
            no_preference: student_data.relevant_ages.no_preference,
            zero_to_one: student_data.relevant_ages.zero_to_one, 
            one_to_two: student_data.relevant_ages.one_to_two,
            two_to_five: student_data.relevant_ages.two_to_five,
            five_to_twelve: student_data.relevant_ages.five_to_twelve,
            twelve_to_twenty_five: student_data.relevant_ages.twelve_to_twenty_five,
            twenty_five_plus: student_data.relevant_ages.twenty_five_plus
        },
        work_on_sunday :{
            is_needed: student_data.work_on_sunday.is_needed,
            start_time: student_data.work_on_sunday.start_time,
            end_time: student_data.work_on_sunday.end_time
        },

        work_on_monday :{
            is_needed: student_data.work_on_monday.is_needed,
            start_time: student_data.work_on_monday.start_time,
            end_time: student_data.work_on_monday.end_time
        },

        work_on_tuesday :{
            is_needed: student_data.work_on_tuesday.is_needed,
            start_time: student_data.work_on_tuesday.start_time,
            end_time: student_data.work_on_tuesday.end_time
        },
        
        work_on_wednesday :{
            is_needed: student_data.work_on_wednesday.is_needed,
            start_time: student_data.work_on_wednesday.start_time,
            end_time: student_data.work_on_wednesday.end_time
        },

        work_on_thursday :{
            is_needed: student_data.work_on_thursday.is_needed,
            start_time: student_data.work_on_thursday.start_time,
            end_time: student_data.work_on_thursday.end_time
        },

        work_on_friday :{
            is_needed: student_data.work_on_friday.is_needed,
            start_time: student_data.work_on_friday.start_time,
            end_time: student_data.work_on_friday.end_time
        },

        work_on_saturday :{
            is_needed: student_data.work_on_saturday.is_needed,
            start_time: student_data.work_on_saturday.start_time,
            end_time: student_data.work_on_saturday.end_time
        }
    })
}

export const saveParentData = (parent_data) => dispatch => {
    const baseDb = myFirebase.firestore();
    var user = myFirebase.auth().currentUser
    baseDb.collection("members").doc(user.uid).set({
        registration_date: parent_data.registration_date,
        activity_status: parent_data.activity_status,
        email : parent_data.email,
        type : "parent",
        full_name : parent_data.full_name,
        phone_number : parent_data.phone_number,
        region : parent_data.region,
        city : parent_data.city,
        child_age : parent_data.child_age,
        child_gender : parent_data.child_gender,
        is_autistic_spectrum : parent_data.is_autistic_spectrum,
        is_intellectual_limitation : parent_data.is_intellectual_limitation,
        is_delayed_developed : parent_data.is_delayed_developed,
        is_physical_limitation : parent_data.is_physical_limitation,
        is_behavioral_difficulty : parent_data.is_behavioral_difficulty,
        is_nursing_assistance : parent_data.is_nursing_assistance,
        is_medical_assistance : parent_data.is_medical_assistance,
        is_other : parent_data.is_other, 
        child_functional_level : parent_data.child_functional_level,
        temp_position : {
            start_date: parent_data.temp_position.start_date,
            end_date: parent_data.temp_position.end_date,
            num_of_children: parent_data.temp_position.start_date,
            salary: parent_data.temp_position.salary,
        },
        extra_child : {
            child_age: parent_data.extra_child.child_age,
            child_gender: parent_data.extra_child.child_gender,
            is_autistic_spectrum: parent_data.extra_child.is_autistic_spectrum,
            is_intellectual_limitation: parent_data.extra_child.is_intellectual_limitation,
            is_delayed_developed: parent_data.extra_child.is_delayed_developed,
            is_physical_limitation: parent_data.extra_child.is_physical_limitation,
            is_behavioral_difficulty: parent_data.extra_child.is_behavioral_difficulty,
            is_nursing_assistance: parent_data.extra_child.is_nursing_assistance,
            is_medical_assistance: parent_data.extra_child.is_medical_assistance,
            is_other: parent_data.extra_child.is_other,
            child_functional_level: parent_data.extra_child.child_functional_level
        },
        work_on_sunday :{
            is_needed: parent_data.work_on_sunday.is_needed,
            start_time: parent_data.work_on_sunday.start_time,
            end_time: parent_data.work_on_sunday.end_time
        },
        
        work_on_monday :{
            is_needed: parent_data.work_on_monday.is_needed,
            start_time: parent_data.work_on_monday.start_time,
            end_time: parent_data.work_on_monday.end_time
        },

        work_on_tuesday :{
            is_needed: parent_data.work_on_tuesday.is_needed,
            start_time: parent_data.work_on_tuesday.start_time,
            end_time: parent_data.work_on_tuesday.end_time
        },
        
        work_on_wednesday :{
            is_needed: parent_data.work_on_wednesday.is_needed,
            start_time: parent_data.work_on_wednesday.start_time,
            end_time: parent_data.work_on_wednesday.end_time
        },

        work_on_thursday :{
            is_needed: parent_data.work_on_thursday.is_needed,
            start_time: parent_data.work_on_thursday.start_time,
            end_time: parent_data.work_on_thursday.end_time
        },

        work_on_friday :{
            is_needed: parent_data.work_on_friday.is_needed,
            start_time: parent_data.work_on_friday.start_time,
            end_time: parent_data.work_on_friday.end_time
        },

        work_on_saturday :{
            is_needed: parent_data.work_on_saturday.is_needed,
            start_time: parent_data.work_on_saturday.start_time,
            end_time: parent_data.work_on_saturday.end_time
        }

    })
}

export const verifyAuth = () => dispatch => {
    dispatch(verifyRequest());
    myFirebase
        .auth()
        .onAuthStateChanged(user => {
            if (user !== null) {
                dispatch(receiveLogin(user));
            }
            dispatch(verifySuccess());
        });
};

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const EMAIL_SENT = "EMAIL_SENT";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const VERIFY_REQUEST = "VERIFY_REQUEST";
export const VERIFY_SUCCESS = "VERIFY_SUCCESS";
export const SAVE_DATA_SUCCESS = "VERIFY_SAVE_DATA";
export const SAVE_DATA_FAILURE = "SAVE_DATA_FAILURE";